import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public static USER_KEY: string = "sessionERP";
  public static COD_SUC_KEY: string = "codsuc"
  public static FILTRO:string = 'filtro_consulta'
  public static GRILLAS_KEY:string = 'v_recursosGlosa'
  public static TEMA_APP: string = 'themeApp'
  
  setData(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  public getData(key: string) {
    return localStorage.getItem(key);
  }

  public static setAll(value: any) {
    localStorage.setItem(this.USER_KEY, JSON.stringify(value));
  }

  public static getSession() {
    return JSON.parse(localStorage.getItem(this.USER_KEY));
  }

  public static obtenerAcceso(accesos: any, codmod: number, codacc: number): any {
    let vResponse: any = null;
    if (accesos != null)
      accesos.forEach((element: any) => {
        if (element.codmod == codmod && element.codacc == codacc) {
          vResponse = element;
        }
      });
    return vResponse
  }

  //AGREGAR CODSUC AL STORAGE
  public static setCodSuc(value:number){
    localStorage.setItem(this.COD_SUC_KEY,value.toString())
  }
  
  public static getCodSuc():number{
    return Number(localStorage.getItem(this.COD_SUC_KEY))
  }

  //AGREGAR GRILLAS AL STORAGE
  public static setGrilla(value:any){
    localStorage.setItem(this.GRILLAS_KEY,JSON.stringify(value))
  }

  public static getGrilla(){
     const data = JSON.parse(localStorage.getItem(this.GRILLAS_KEY))
     return data ?? []
  }

  //FILTROS CONSULTA

  public static setFiltro(value:any){
    localStorage.setItem(this.FILTRO,JSON.stringify(value))
  }
  
  public static getFiltro():any{
    return JSON.parse(localStorage.getItem(this.FILTRO))
  }

  public static deleteFiltro(){
    localStorage.removeItem(this.FILTRO);
  }

  // TEMA DARK MODE
  public static setTema(value:'dark' | 'light'){
    localStorage.setItem(this.TEMA_APP,value)
  }

  public static getTema(){
     const tema = localStorage.getItem(this.TEMA_APP)
     return tema ?? 'light'
  }

  removeData(key: string) {
    localStorage.removeItem(key);
  }

  public static clearStorage() {

    const keys = Object.keys(localStorage)
    let count = keys.length;

    while (count--) {
      keys[count] == this.TEMA_APP ? null : localStorage.removeItem(keys[count])
    }
  }

}
